import {
  deliveryEstimateSelectorSchema,
  SelectorType,
} from "@redotech/redo-conversion-core-common/conversion/storefront-delivery-estimate";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const updateStorefrontDeliveryEstimateSelector = {
  name: "updateStorefrontDeliveryEstimateSelector" as const,
  input: z.object({
    selector: deliveryEstimateSelectorSchema,
    selectorType: createEnum(SelectorType),
  }),
  output: z.null(),
};
